import produce from "immer"

const initialState = {
    error: undefined,
    data: undefined,
    billing: undefined,
    billingError: undefined,
    trips: undefined,
    tripsError: undefined,
    vehicleDetails: undefined,
    vehicleDetailsError: undefined,
    ride: undefined,
    rideError: undefined,
    userRidesSummary: undefined,
    userRidesSummaryError: undefined,
}

export const reducer = produce((draft, action) => {
    switch (action.type) {
        case "RIDE_STARTED": {
            draft.vehicleDetails = undefined
            break;
        }
        case "START_RIDE_REQUEST": {
            draft.data = undefined
            draft.error = undefined
            break;
        }
        case "START_RIDE_SUCCESS": {
            draft.data = action.response
            break;
        }
        case "START_RIDE_FAILURE": {
            draft.error = action.error
            break;
        }
        case "RIDE_BILLING_REQUEST": {
            draft.billing = undefined
            draft.billingError = undefined
            break;
        }
        case "RIDE_BILLING_SUCCESS": {
            draft.billing = action.response
            break;
        }
        case "RIDE_BILLING_FAILURE": {
            draft.billingError = action.error
            break;
        }
        case "FETCH_TRIPS_REQUEST": {
            draft.trips = undefined
            draft.tripsError = undefined
            break;
        }
        case "FETCH_TRIPS_SUCCESS": {
            draft.trips = action.response
            break;
        }
        case "FETCH_TRIPS_FAILURE": {
            draft.tripsError = action.error
            break;
        }
        case "VEHICLE_DETAILS_REQUEST": {
           // draft.vehicleDetails = undefined
            //draft.vehicleDetailsError = undefined
            break;
        }
        case "VEHICLE_DETAILS_SUCCESS": {
            draft.vehicleDetails = action.response
            break;
        }
        case "VEHICLE_DETAILS_FAILURE": {
            draft.vehicleDetailsError = action.error
            break;
        }
        case "RIDE_LOCK_REQUEST": {
            draft.rideLock = undefined
            draft.rideLockError = undefined
            break;
        }
        case "RIDE_LOCK_SUCCESS": {
            draft.rideLock = action.response
            break;
        }
        case "RIDE_LOCK_FAILURE": {
            draft.rideLockError = action.error
            break;
        }
        case "RIDE_UNLOCK_REQUEST": {
            draft.rideUnlock = undefined
            draft.rideUnlockError = undefined
            break;
        }
        case "RIDE_UNLOCK_SUCCESS": {
            draft.rideUnlock = action.response
            break;
        }
        case "RIDE_UNLOCK_FAILURE": {
            draft.rideUnlockError = action.error
            break;
        }
        case "FETCH_RIDE_REQUEST": {
            draft.ride = undefined;
            draft.rideError = undefined;
            break;
        }
        case "FETCH_RIDE_SUCCESS": {
            draft.ride = action.response;
            break;
        }
        case "FETCH_RIDE_FAILURE": {
            draft.rideError = action.error;
            break;
        }
        case "FETCH_USER_RIDES_SUMMARY_REQUEST": {
            draft.userRidesSummary = undefined;
            draft.userRidesSummaryError = undefined;
            break;
        }
        case "FETCH_USER_RIDES_SUMMARY_SUCCESS": {
            draft.userRidesSummary = action.response;
            break;
        }
        case "FETCH_USER_RIDES_SUMMARY_FAILURE": {
            draft.userRidesSummaryError = action.error;
            break;
        }
    }
}, initialState)

function deRoot(state) {
    return state.ride
}

export function selectStarted(state) {
    return deRoot(state).started
}

export function selectFinished(state) {
    return deRoot(state).finished
}

export function selectBilling(state) {
    return deRoot(state).billing
}

export function selectBillingError(state) {
    return deRoot(state).billingError
}

export function selectTrips(state) {
    return deRoot(state).trips
}

export function selectVehicleDetails(state) {
    return deRoot(state).vehicleDetails
}

export function selectRide(state) {
    return deRoot(state).ride
}

export function selectUserRidesSummary(state) {
    return deRoot(state).userRidesSummary
}
